module.exports = __webpack_public_path__ + "static/img/bj.f7fbd74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bj.png
// module id = jg0z
// module chunks = 52